export default {
  header: "This is who am",
  view: "Bio",
};
